import { render } from "./CardAdministrator.vue?vue&type=template&id=13d8f81e"
import script from "./CardAdministrator.vue?vue&type=script&lang=js"
export * from "./CardAdministrator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__